import { fetchProtectedDocument } from './protected-document';

export type ReceiptShareResult = 'shared' | 'copied-and-opened' | 'downloaded-and-opened';

const download = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
};

const openWhatsApp = (text: string) => {
  const popup = window.open(
    `whatsapp://send?text=${encodeURIComponent(text)}`,
    '_blank',
    'noopener',
  );
  if (!popup) window.location.href = `https://wa.me/?text=${encodeURIComponent(text)}`;
};

export async function sharePaymentReceiptViaWhatsApp(input: {
  url: string;
  receiptNumber: string;
  memberName?: string;
  appliedAmount: string;
}): Promise<ReceiptShareResult> {
  const memberLine = input.memberName ? `\nSocio: ${input.memberName}` : '';
  const text = `COMIVALLE \u00b7 Recibo oficial ${input.receiptNumber}${memberLine}\nValor aplicado: USD ${input.appliedAmount}\nAdjuntamos el comprobante oficial emitido por URBANIK.`;
  const { blob } = await fetchProtectedDocument(input.url, `${input.receiptNumber}.png`);
  const imageBlob = blob.type === 'image/png' ? blob : new Blob([blob], { type: 'image/png' });
  if (window.urbanikPlatform?.shareReceiptToWhatsApp) {
    await window.urbanikPlatform.shareReceiptToWhatsApp({
      imageBytes: new Uint8Array(await imageBlob.arrayBuffer()),
      text,
    });
    return 'copied-and-opened';
  }
  const file = new File([imageBlob], `${input.receiptNumber}.png`, { type: 'image/png' });
  if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
    await navigator.share({ title: `Recibo ${input.receiptNumber}`, text, files: [file] });
    return 'shared';
  }
  download(imageBlob, file.name);
  openWhatsApp(text);
  return 'downloaded-and-opened';
}
